module.exports = __webpack_public_path__ + "fonts/avenir/294099f3-8d00-4676-afc5-5e9d8d43ad69.svg";


//////////////////
// WEBPACK FOOTER
// ./fonts/avenir/294099f3-8d00-4676-afc5-5e9d8d43ad69.svg
// module id = 43
// module chunks = 0